import React, { useEffect, useRef, useState } from "react";
import carImg from "../Hotel/Images/image_7-removebg-preview.png";
import hotelImg from "../Hotel/Images/image_8-removebg-preview.png";
import "../Hotel/CSS/Hotel.css";

const CarLoader = ({ progress, isLoading, label = "Loading...", doneLabel = "You've arrived!" }) => {
  const [autoProgress, setAutoProgress] = useState(0);
  const intervalRef = useRef(null);
  const isAutoMode = typeof progress !== "number";
  useEffect(() => {
    if (!isAutoMode) return;
    if (isLoading) {
      setAutoProgress(0);
      intervalRef.current = setInterval(() => {
        setAutoProgress((prev) => {
          if (prev >= 90) return prev;
          return prev + Math.random() * 8 + 2;
        });
      }, 250);
    } else {
      clearInterval(intervalRef.current);
      setAutoProgress(100);
    }

    return () => clearInterval(intervalRef.current);
  }, [isLoading, isAutoMode]);

  const value = Math.min(100, Math.round(isAutoMode ? autoProgress : progress));
  const isDone = value >= 100;

  return (
    <div className="car-loader">
      <div className="car-loader__track">
        <div className="car-loader__road" />
        <div className="car-loader__hotel">
          <img src={hotelImg} alt="Hotel" />
        </div>
        <div className="car-loader__car" style={{ left: `calc(${value}% - ${value * 0.5}px)` }}>
          <img src={carImg} alt="Car" />
        </div>
      </div>

      <div className="car-loader__bar-row">
        <div className="car-loader__bar-track">
          <div className="car-loader__bar-fill" style={{ width: `${value}%` }} />
        </div>
        <span className="car-loader__pct">{value}%</span>
      </div>

      <p className="car-loader__label">{isDone ? doneLabel : label}</p>
    </div>
  );
};

export default CarLoader;